import { MediaType } from '../types';

/** Launch flag: voice-guided mode is hidden for first launch (2026-07-30).
    Flip to true to restore the admin selectors, task prompt recording and
    the participant VoiceGuidedShell — no other change needed. */
export const VOICE_GUIDED_ENABLED = false;

/** Voice-guided (low-literacy) mode: the literacy-free capture types only.
    null = no restriction. Spec: 2026-07-30-voice-guided-low-literacy-mode-design.md */
export const allowedMediaTypesForUiMode = (
  mode: string | undefined
): MediaType[] | null =>
  mode === 'voice_guided' ? [MediaType.Audio, MediaType.Video, MediaType.Photo] : null;
